import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { Menu } from 'tdesign-react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { changeFavico, getRootPath } from '@/utils/common';
import { doCacheClusterModule } from '@/slices/layoutSlice';
import { fetchFrontConfig } from '@/slices/platformSlice';
import RightOperations from './RightOperations';

const { HeadMenu, MenuItem } = Menu;

const clusterPaths = ['/cluster', '/kop-cluster'];

// 顶层菜单，取用menus一级
function Header({ menus, doCacheClusterModule, currentModule, fetchFrontConfig, frontConfig }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const topPath = getRootPath(pathname); // 一级路径

  useEffect(() => {
    fetchFrontConfig();
  }, [fetchFrontConfig]);

  useEffect(() => {
    changeFavico(frontConfig.favico);
    document.title = frontConfig.title;
  }, [frontConfig]);

  const menuClick = (path) => {
    navigate(path);
  };

  const [businessMenus, systemMenus] = useMemo(() => {
    // 当前需要显示的集群管理一级菜单
    let clusterMenu;
    const businessMenus = [];
    const systemMenus = [];
    const _menus = menus.filter((menu) => {
      // 过滤掉集群菜单
      if (clusterPaths.includes(menu.path)) {
        // 只显示当前选中的集群（pulsar/kop）
        if (currentModule === menu.path) {
          clusterMenu = menu;
        }
        return false;
      }

      return true;
    });
    // 第一个一级菜单（集群）
    if (clusterMenu) {
      businessMenus.push(clusterMenu);
    }

    _menus.forEach((menu) => {
      if (menu.resource !== 'pulsar:sys') {
        businessMenus.push(menu);
      } else {
        systemMenus.push(menu);
      }
    });

    return [businessMenus, systemMenus];
  }, [menus, currentModule]);

  useEffect(() => {
    if (clusterPaths.includes(topPath)) {
      // 缓存现在的模块
      doCacheClusterModule(topPath);
    }
  }, [topPath, doCacheClusterModule]);

  return (
    <Root>
      <HeadMenu
        theme='light'
        value={topPath}
        logo={
          <img
            style={{ cursor: 'pointer', maxWidth: 200, maxHeight: 40 }}
            onClick={() => navigate(currentModule)}
            src={frontConfig['head-logo']}
            alt='logo'
          />
        }
        operations={<RightOperations />}
      >
        {businessMenus.map((menu) => (
          <MenuItem key={menu.path} value={menu.path} onClick={() => menuClick(menu.path)}>
            <span>{menu.label}</span>
          </MenuItem>
        ))}
        <SystemMenuContainer>
          {systemMenus.map((menu) => (
            <MenuItem key={menu.path} value={menu.path} onClick={() => menuClick(menu.path)}>
              <span>{menu.label}</span>
            </MenuItem>
          ))}
        </SystemMenuContainer>
      </HeadMenu>
    </Root>
  );
}

export default connect(
  (state) => ({
    menus: state.layout.menus,
    currentModule: state.layout.currentModule,
    frontConfig: state.platform.frontConfig,
  }),
  {
    doCacheClusterModule,
    fetchFrontConfig,
  },
)(Header);

const Root = styled.div`
  display: flex;
  align-items: center;
  .t-head-menu {
    margin-bottom: 0;
    padding-left: 24px;
    background-color: transparent;
  }
  .t-head-menu__inner {
    height: 60px;
  }
  .t-menu__item {
    &.t-is-active {
      background: linear-gradient(274.46deg, #194dff 0%, #0000ff 376.74%);
      mix-blend-mode: normal;
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
    }
  }
`;

const SystemMenuContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
`;
